const UI_ONLY_BOOKING_FORM_KEYS = ["companyTenants", "commercial", "tenantType"] as const;

export const omitBookingFormUiFields = <T extends Record<string, unknown>>(bookingForm: T) => {
  const payload = { ...bookingForm };

  UI_ONLY_BOOKING_FORM_KEYS.forEach((key) => {
    delete payload[key];
  });

  return payload;
};
